<template>
  <Tree
    :data="data5"
    :load-data="fetchChildrenGroups"
    :render="renderContent"
  ></Tree>
</template>

<script>
  import {base_url} from "../../http.js";

  export default {
    name: "groupTree",
    data() {
      return {
        base_view_url: base_url + "/catalog/groups/",
        data5: [],
        buttonProps: {
          type: 'default',
          size: 'small',
        }
      }
    },
    methods: {
      renderContent(h, {root, node, data}) {
        let nodeElements = h('div',
            {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                }
            },
            [
          h({
            props: {
              type: 'ios-paper-outline'
            },
            style: {
              marginRight: '8px', display: 'inline-block'
            }
          }),
          h('h5', data.title),

          h('Tooltip',
            {
              props: {
                content: 'Редактировать группу',
                // placement: 'left-end'
              }
            },
            [
              h('Button', {
                props: Object.assign({}, this.buttonProps, {
                  icon: 'md-create'
                }),
                style: {
                  marginLeft: '8px',  color: '#DEDEDE', boxShadow: 'none', border: 'none', display: 'inline-block'
                },
                on: {
                  click: () => {
                    this.showEdit(data)
                  }
                }
              })
            ]
          )
        ]);

        let actions = [
          // // APPEND BUTTON
          // h('Tooltip',
          //   {
          //     props: {
          //       content: 'Добавить группу',
          //       // placement: 'left-end'
          //     }
          //   },
          //   [
          //     h('Button', {
          //       props: Object.assign({}, this.buttonProps, {
          //         icon: 'ios-add',
          //           type: 'info'
          //       }),
          //       style: {
          //         marginRight: '8px', width: '36px', height: '36px', borderRadius: '50%', padding: '0'
          //       },
          //       on: {
          //         click: () => {
          //           this.append(data)
          //         }
          //       }
          //     }),
          //   ]
          // ),
          // REMOVE BUTTON
          h('Tooltip',
            {
              props: {
                content: 'Удалить группу',
                // placement: 'left-end'
              }
            },
            [
              h('Button', {
                props: Object.assign({}, this.buttonProps, {
                  icon: 'ios-remove',
                    type: 'error'
                }),
                  style: {
                      width: '36px', height: '36px', borderRadius: '50%', padding: '0'
                  },
                on: {
                  click: () => {
                    this.remove(root, node, data)
                  }
                }
              })
            ]
          ),
        ];

        if (data.showEdit) {
          nodeElements = h('span', [
            h({
              props: {
                type: 'ios-paper-outline'
              },
              style: {
                margin: '12px 8px', display: 'inline-flex'
              }
            }),
            h('input', {
              domProps: {
                value: data.title
              },
                style: {
                    border: 'none', boxShadow: '0 3px 6px rgba(0,0,0,0.16)', borderRadius: '18px', padding: '10px'
                },
              on: {
                input: (event) => {
                  this.saveGroupIntoNode(data, event)
                }
                // input: function (event) {
                //   self.$emit('input', event.target.value)
                // }
              }
            }),
            h('Tooltip',
              {
                props: {
                  content: 'Сохранить группу',
                  // placement: 'left-end'
                }
              },
              [
                h('Button', {
                  props: Object.assign({}, this.buttonProps, {
                    icon: 'md-checkmark',
                      type: 'success'
                  }),
                  style: {
                    marginLeft: '8px', width: '36px', height: '36px', borderRadius: '50%', padding: '0'
                  },
                  on: {
                    click: () => {
                      this.saveGroup(root, node, data)
                    }
                  }
                }),
              ]
            ),
          ]);
          actions = [
            // REMOVE BUTTON
            h('Tooltip',
              {
                props: {
                  content: 'Удалить группу',
                  // placement: 'left-end'
                }
              },
              [
                h('Button', {
                  props: Object.assign({}, this.buttonProps, {
                    icon: 'ios-remove',
                      type: 'error'
                  }),
                    style: {
                        width: '36px', height: '36px', borderRadius: '50%', padding: '0'
                    },
                  on: {
                    click: () => {
                      this.remove(root, node, data)
                    }
                  }
                }),
              ]
            ),

          ]
        }

        return h('div', {
          style: {
            display: 'inline-flex',
              justifyContent: 'space-between',
            width: '100%',
              marginRight: '8px',
              paddingLeft: '12px'
          }
        }, [
          nodeElements,
          h('h5', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          }, actions)
        ]);
      },
      append(data) {
        // console.log(data);
        const children = data.children || [];
        children.push({
          // title: `Группа ${data.nodeKey}`,
          title: "Новая группа",
          // parent: data.id,
          expand: true,
          showEdit: true,
          selected: true,
          loaded: false
        });
        this.$set(data, 'children', children);
        this.$set(data, 'expand', true);
        // this.$set(data, 'showEdit', true);
        // this.$set(data, 'loaded', false);
        // this.$emit('load-data');
        if (!data.loaded) this.fetchChildrenGroups2(data);
        // console.log(fetchedChildren);
      },
      removeNode(root, node, data) {
        const parentKey = root.find(el => el === node).parent;
        const parent = root.find(el => el.nodeKey === parentKey).node;
        const index = parent.children.indexOf(data);
        parent.children.splice(index, 1);
      },
      remove(root, node, data) {
        if (data.id !== undefined) {
          this.delete(root, node, data);
        } else {
          this.removeNode(root, node, data);
        }

      },
      showEdit(data) {
        this.$set(data, 'showEdit', true);
      },
      saveGroupIntoNode(data, event) {
        // this.$set(data, 'showEdit', false);
        // console.log(data);
        // console.log(event);
        data.title = event.target.value;
      },
      saveGroup(root, node, data) {
        const parentKey = root.find(el => el === node).parent;
        const parentId = root.find(el => el.nodeKey === parentKey).node.id;

        // console.log(parentId);

        if (data.id !== undefined) {
          this.savePut(data);
        } else {
          this.savePost(data, parentId);
        }

      },

      fetchGroups() {
        const url = `${this.base_view_url}?parent=true`;
        this.$http
          .get(url)
          .then(result => {
            if (result.data.results) {
              // this.data5 = [];
              for (const item of result.data.results) {
                let item_data = {
                  id: item.id,
                  title: item.name,
                  // expand: true,
                  showEdit: true,
                  loaded: false,
                  render: (h, {root, node, data}) => {
                    return h('span', {
                      style: {
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '12px',
                        width: '100%'
                      }
                    }, [
                      h('h5', [
                        h({
                          props: {
                            type: 'ios-folder-outline'
                          },
                          style: {
                            marginRight: '8px'
                          }
                        }),
                        h('span', data.title)
                      ]),
                      h('span', {
                        style: {
                          display: 'inline-block',
                          float: 'right',
                          marginRight: '32px'
                        }
                      }, [
                        h('Tooltip',
                          {
                            props: {
                              content: 'Добавить группу',
                              // placement: 'left-end'
                            }
                          },
                          [h('Button', {
                            props: Object.assign({}, this.buttonProps, {
                              icon: 'ios-add',
                              type: 'info'
                            }),
                            style: {
                                width: '36px', height: '36px', borderRadius: '50%', padding: '0'
                            },
                            on: {
                              click: () => {
                                this.append(data)
                              }
                            }
                          })  ]
                        )
                      ])
                    ]);
                  },
                  // loading: false,
                };
                if (item.has_children) {
                  item_data.children = [];
                  item_data.loading = false;
                }
                this.data5.push(item_data);
              }
              // this.loadedGroups = true;
            }
          })
          .catch(error => {
            this.$Message.error("Произошла ошибка");
          });
      },

      fetchChildrenGroups(item, callback) {
        const url = `${this.base_view_url}${item.id}/children/`;
        this.$http
          .get(url)
          .then(result => {
            if (result.data.results) {
              let data = [];
              for (const item of result.data.results) {
                let item_data = {
                  id: item.id,
                  title: item.name,
                  selected: true,
                  // loaded: true,
                  // showEdit: true,
                };
                if (item.has_children) {
                  item_data.children = [];
                  item_data.loading = false;
                }
                data.push(item_data);
              }
              callback(data);
              item.loaded = true
            }
          })
          .catch(error => {
            this.$Message.error("Произошла ошибка");
          });
      },
      fetchChildrenGroups2(itemData) {
        const url = `${this.base_view_url}${itemData.id}/children/`;
        this.$http
          .get(url)
          .then(result => {
            if (result.data.results) {
              let children_data = [];
              for (const item of result.data.results) {
                let item_data = {
                  id: item.id,
                  title: item.name,
                };
                if (item.has_children) {
                  item_data.children = [];
                  item_data.loading = false;
                }
                // children_data.push(item_data);
                itemData.children.push(item_data);
              }
              // item.children.push(children_data);
              // console.log(children_data)
              itemData.loaded = true;
            }
          })
          .catch(error => {
            this.$Message.error("Произошла ошибка");
          });
      },

      savePost(data, parentId) {
        const url = `${this.base_view_url}`;
        let post_data = {
          'name': data.title,
          'parent': parentId
        };
        // this.loading = true;
        this.$http.post(url, post_data)
          .then(response => {
            this.$Message.success("Успешно сохранено");
            this.$set(data, 'showEdit', false);
            data.id = response.data.id;
            this.$emit('new-group',  data.id)

          })
          .catch(error => {
            this.$Message.error(
              "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки."
            );
          })
          .then(() => {
            // this.loading = false;
          });
      },

      savePut(data) {
        const url = `${this.base_view_url}${data.id}/`;
        let post_data = {
          'name': data.title,
        };
        // this.loading = true;
        this.$http.put(url, post_data)
          .then(response => {
            this.$Message.success("Успешно сохранено");
            this.$set(data, 'showEdit', false);

          })
          .catch(error => {
            this.$Message.error(
              "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки."
            );
          })
          .then(() => {
            // this.loading = false;
          });
      },

      delete(root, node, data) {
        const url = `${this.base_view_url}${data.id}/`;

        this.$http.delete(url)
          .then(response => {
            this.$Message.success("Успешно удалено");
            this.removeNode(root, node, data);
          })
          .catch(error => {
            this.$Message.error(
              "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки."
            );
          })
          .then(() => {
            // this.loading = false;
          });
      }

    },
    mounted() {
      this.fetchGroups();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/apps/catalog/groupTree.vue